import React, { useEffect, useState } from "react";

function GetCryptoValues() {




  return null;
}

export default GetCryptoValues;
